import Form from "./form"
import Locations from "./locations";
import Top from "./top";
import { ILocation, IQuestion } from "./models";

if(document.readyState === 'complete') {
  init()
} else {
  document.addEventListener('DOMContentLoaded', init)
}

declare global{
  interface Window {
    FORM_LOCATIONS: Array<ILocation>
    FORM_QUESTIONS: Array<IQuestion>
    FAILED_CONTENT: string
    PASSED_CONTENT: string
  }
}

function init(){
  const top = document.getElementById('top') as HTMLDivElement;
  if(top){
    var header = new Top(top)
    const locations = document.getElementById('locations') as HTMLDivElement;
    if (locations) {
      var locs = new Locations(locations, header)
      const form = new Form(window.FORM_QUESTIONS, header)
      const survey = document.getElementById('survey')
      if(survey){
        survey.innerHTML = ""
        survey.appendChild(form.element)
        locs.onhide(() => {
          form.show()
        })
      }
    }
  }
}